import DInlineFloat from "float-kit/components/d-inline-float";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
import templateOnly from "@ember/component/template-only";
const DHeadlessMenu = setComponentTemplate(precompileTemplate("\n  <DInlineFloat @instance={{@menu}} @trapTab={{@menu.options.trapTab}} @mainClass=\"fk-d-menu\" @innerClass=\"fk-d-menu__inner-content\" @role=\"dialog\" @inline={{@inline}} />\n", {
  strictMode: true,
  scope: () => ({
    DInlineFloat
  })
}), templateOnly(undefined, "d-headless-menu:DHeadlessMenu"));
export default DHeadlessMenu;